import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

const NotificationHandler: React.FC = () => {
    console.log('🔧 NotificationHandler Rendered');
    usePushNotifications();
    return null;
};

export default NotificationHandler;
